import config from '../config';

export async function fetchSiteAlertsHistorical(backendFetch, siteId, fromts, tots) {
    fromts = Math.round(fromts.getTime() / 1000);
    tots = Math.round(tots.getTime() / 1000);
    const response = await backendFetch(config.REACT_APP_HOST + "/api/v2/alerts/historical/" + siteId + "?fromts=" + fromts + "&tots=" + tots)
    let alerts = await response.json();
    if (alerts !== undefined && alerts && alerts.length !== 0) {
        alerts = alerts.sort((a, b) => b.valid_from - a.valid_from);
    }
    return alerts
}

export async function fetchSiteAlerts(backendFetch, siteId) {
    const response = await backendFetch(config.REACT_APP_HOST + "/api/v2/alerts/" + siteId);
    let alerts = await response.json();
    if (alerts !== undefined && alerts && alerts.length !== 0) {
        alerts = alerts.sort((a, b) => b.valid_from - a.valid_from);
    }
    return alerts;
}

export async function fetchAllActiveSiteAlertMutes(backendFetch) {
    let url = config.REACT_APP_HOST + "/api/v2/alerts/mutes";
    const response = await backendFetch(url);
    const text = await response.text();
    return JSON.parse(text.replace(/\bNaN\b/g, "null"));
}

export async function fetchActiveSiteAlertMutes(backendFetch, siteId, deviceId = null) {
    let url = config.REACT_APP_HOST + "/api/v2/alerts/mutes/" + siteId;
    if (deviceId) {
        url += "?device_id=" + deviceId;
    }
    const response = await backendFetch(url);
    const text = await response.text();
    return JSON.parse(text.replace(/\bNaN\b/g, "null"));
}

export async function createSiteAlertMute(backendFetch, siteId, muteData) {
    const response = await backendFetch(config.REACT_APP_HOST + "/api/v2/alerts/mutes/" + siteId, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(muteData),
    });
    return await response.json();
}

export async function disableSiteAlertMute(backendFetch, muteId) {
    const response = await backendFetch(config.REACT_APP_HOST + "/api/v2/alerts/mutes/" + muteId, {
        method: 'DELETE',
    });
    return await response.json();
}
